<template>
	<!-- :style="faceSize" -->
	<div class="ChatPage">
		<div class="header">
			<JwChat-item :config="config" @click="bindClick" />
			<slot name="header" />
		</div>
		<div class="header_line"></div>
		<div class="chatBox">
			<JwChat :taleList="taleList" @enter="enter" v-model="msg" :toolConfig="toolConfig" :scrollType="scrollType" :width="chatWidth"
			:height="chatHeight" :config="chatConfig" :userInfo="userInfo"> //@clickTalk="$emit('clickTalk1',$event)"
				<slot name="tools" slot="tools" />
			</JwChat>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "JwChat-index",
		props: {
			config: {
				type: Object,
				default: () => ({
					name: 'wangshan23',
					ipdress: '南京',
					number:'4',
					tags:[{
						tid:'1',
						tname: '标签1'
					},
					{
						tid:'2',
						tname: '标签2'
					}],
				}),
				callback: () => {}
			},
			userInfo: {
				type:Object,
			},
			taleList: {
				type: Array,
				default: () => {
					return []
				}
			},
			height: {
				type: String,
				default: "570"
			},
			width: {
				default: "750"
			},
			value: {
				default: ''
			},
			toolConfig: {
				type: Object
			},
			scrollType: {
				default: "noroll"
			},
		},
		data() {
			return {
				chatHeight: '',
				chatWidth: "",
				msg: ''
			}
		},
		computed: {
			// faceSize () {
			//   let height = this.height
			//   let width = this.width
			//   if (height.match(/\d$/)) {
			//     height += 'px'
			//   }
			//   if (width.match(/\d$/)) {
			//     width += 'px'
			//   }
			//   const style = { height, width }
			//   return style
			// },
			chatConfig() {
				const {
					historyConfig = {}
				} = this.config || {}
				return {
					historyConfig
				}
			},
		},
		watch: {
			// height: {
			//   handler () {
			//     this.chatHeight = this.height - 60 + ''
			//   },
			//   immediate: true
			// },
			// width: {
			//   handler () {
			//     this.chatWidth = this.width * .7 + ''
			//   },
			//   immediate: true
			// },
			value: {
				handler() {
					this.msg = this.value;
				},
				immediate: true
			},
			msg: {
				handler() {
					this.$emit('input', this.msg);
				},
				immediate: true
			},
			
			userInfo(newVal, oldVal) {
				console.log('chatInterface index watch userInfo new = ', newVal)
				console.log('chatInterface index watch userInfo old = ', oldVal)
			},
			
		},
		methods: {
			bindClick(type) {
				console.log('chatinterface bindclick type = ', type)
				const {
					callback
				} = this.config || {}
				if (callback) {
					callback(type)
				}
			},
			enter(msg) {
				console.log('chatInterface enter msg = ', msg)
				this.$emit('enter', msg)
			}
		}
	}
</script>

<style scoped>
	.ChatPage {
		margin: 0 auto;
		display: flex;
		flex-direction: column;
	}
	
	.header {
		height: 100px;
		width: 95%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 15px 0 0 15px;
	}
	
	.header_line {
		width: 100%;
		height: 4px;
		background-color: #E2E8F0;
		z-index: 1;
	}
	
	.chatBox {
		display: flex;
		flex-direction: column;
		width: 670px;
		height: 680px;
		
	}

</style>
